import { render, staticRenderFns } from "./ProjetoTarefas.vue?vue&type=template&id=74e21cf8&scoped=true"
import script from "./ProjetoTarefas.vue?vue&type=script&lang=js"
export * from "./ProjetoTarefas.vue?vue&type=script&lang=js"
import style0 from "./ProjetoTarefas.vue?vue&type=style&index=0&id=74e21cf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e21cf8",
  null
  
)

export default component.exports